import React, {useState, useEffect, useRef, useContext} from "react";
import {DEFAULT_BLUE} from "../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {functions} from "../constants/common-functions";
import {useHistory} from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import {NO_STRINGIFY} from "../constants/general-constants";
import {store} from '../context/store';
import Header from "../components/Header";
import LeftMenu from "../components/LeftMenu";

export default function UploadFloorPlanPdf(){
	const globalState = useContext(store);
	const [floors, setFloors] = useState([]);
	const [isLoaded, setIsLoaded] = useState(false);
	const [selectedFloorId, setSelectedFloorId] = useState(-1);
	const [checkBoxBackground, setCheckBoxBackground] = useState("");
	const [isModel, setIsModel] = useState(0);
	const [iconVisibility, setIconVisibility] = useState("none");
	const [standardDisplay, setStandardDisplay] = useState("flex");
	const [submitDisplay, setSubmitDisplay] = useState("none");
	const [successDisplay, setSuccessDisplay] = useState("none");
	const [failureDisplay, setFailureDisplay] = useState("none");
	const [fileDisplay, setFileDisplay] = useState("none");
	
	const [boxBackground, setBoxBackground] = useState("rgba(0,0,0,0.7)");
	const [boxTextColor, setBoxTextColor] = useState("white");
	
	const history = useHistory();  
	const refFile = useRef(null);
	
	useEffect(() => {
		if(isLoaded === false){
			loadFloors();
			setIsLoaded(true);
		}
	}, []);
	
	const loadFloors = () => {
		functions.getObjectFromAjax("/resolutionsoftwareplatform/floors", setFloors, null);
	};

	 const thisContainer = {
  	display:"flex",
  	position:"fixed",
  	flexDirection:"column",
  	width:"100%",
  	height:"100vh",
  	left:"0px",
  	top:"0px",
  	//backgroundColor:GREY_BACKGROUND
  };
  
  const mainContainer = {
  	display:"flex",
  	position:"fixed",
  	top:"60px",
  	left:"60px",
  	bottom:"0px",
  	right:"0px",
  	flexDirection:"column",
  	overflow:"auto"
  };
	
	const uploadpanel = {
		display:'flex',
		width:"1000px",
		backgroundColor:boxBackground,
		flexDirection:'column',
		borderRadius:"4px",
		margin:"auto",
		marginTop:"100px",
		marginBottom:"0px",
		border:"1px solid white",
		paddingBottom:"20px"
	};
	
	const defaultClick = () => {
		alert("Default Click");
	};
	
	const goHome = () => {
		history.push('/home');
	};
	
	const handleSubmit = () => {
		setStandardDisplay("none");
		setSubmitDisplay("flex");
		let formData = new FormData();
		formData.append("floorId", selectedFloorId);
		formData.append("file", refFile.current.files[0]);
		functions.submitAjax("/resolutionsoftwareplatform/uploadfloorplanpdf", 
				formData, handleSuccess, NO_STRINGIFY, handleSubmitError);
	};
	
	const handleSuccess = (returnObj) => {
		console.log(returnObj.urn);
		const timer = setTimeout(() => {
			setSubmitDisplay("none");
			setSuccessDisplay("flex");
			const timer1 = setTimeout(() => {
				setSuccessDisplay("none");
				setStandardDisplay("flex");
			}, 1000);
		}, 3000);
	};
	
	const handleSubmitError = (e) => {
		const timer = setTimeout(() => {
			setSubmitDisplay("none");
			setFailureDisplay("flex");
			const timer1 = setTimeout(() => {
				setFailureDisplay("none");
				setStandardDisplay("flex");
			}, 1000);
		}, 3000);
		console.log(e);
	};
	
	const buttonContainer = {
		display:'flex',
		margin:"auto",
		height:"100px",
		marginTop:"70px"
	};
	
	const uploadRow = {
		display:'flex',
		height:"60px",
		alignItems:"center"
	};
	
	const label = {
		display:'flex',
		width:"300px",
		color:boxTextColor,
		fontSize:"21px",
		paddingLeft:"20px"	
	};
	
	const inputPanel = {
		display:'flex',
		flexGrow:"1",
		marginRight:"20px"
	};
	
	const blueButton = {
		display:"flex",
		width:"30px",
		height:'30px',
		border:"1px solid " + DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		borderRadius:"4px",
		cursor:"pointer"
	};
	
	const panelIcon = {
		display:'flex',
		width:"20px",
		height:"20px",
		color:"white"
	};
	
	const handleCheckBoxClick = () => {
		if(isModel === 0){
			setIsModel(1);
			setCheckBoxBackground(DEFAULT_BLUE);
			setIconVisibility("flex");
		}
		else{
			setIsModel(0);
			setCheckBoxBackground("");
			setIconVisibility("none");
		}
	};
	
	const checkBox = {
		display:"flex",
		width:"30px",
		height:'30px',
		border:"1px solid " + DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		borderRadius:"4px",
		cursor:"pointer"
	};
	
	const processPanel = {
		display:'flex',
		width:"1000px",
		backgroundColor:"rgba(0,0,0,0.7)",
		flexDirection:'column',
		borderRadius:"4px",
		margin:"auto",
		marginTop:"100px",
		height:"400px",
		border:"1px solid " + DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		color:"white"
	};
	
	const successIcon = {
		display:'flex',
		width:"100px",
		height:"100px",
		color:"green"
	};
	
	const failureIcon = {
		display:'flex',
		width:"100px",
		height:"100px",
		color:"white"
	};
	
	const fileInput = {
		display:"flex",
		width:"200px",
		backgroundColor:"black",
		color:"white",
		border:"1px solid darkgrey"
	};
	
	const showFile = () => {
		if(fileDisplay === "flex"){
			setFileDisplay("none");
		}
		else{
			setFileDisplay("flex");
		}
	};
	
	const bigBlueButton = {
		display:"flex",
		width:"200px",
		height:"40px",
		backgroundColor:DEFAULT_BLUE,
		borderRadius:"4px",
		alignItems:"center",
		justifyContent:"space-around",
		alignItems:"center",
		cursor:"pointer",
		margin:"10px",
		color:"white",
		fontSize:"21px"
	};
	
	const thisSelect = {
		display:"flex",
		flexGrow:"1",
		marginRight:"10px",
		height:"40px",
		paddingLeft:"10px",
		fontSize:"16px",
		color:"white",
		backgroundColor:"rgba(0,0,0,0)",
		border:"1px solid white"
	};
	
	const optionDisplay = floors.map((item, index) => 
		<option value={item.id}>
			{item.name}
		</option>
	);
	
	const handleSelectChange = (e) => {
		setSelectedFloorId(e.target.value);
	};
	
	

	return (
		
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>	
				<div style={mainContainer}>
						<div style={{...uploadpanel, display:standardDisplay}}>
					<div style={uploadRow}>
						<div style={label}>
							Select a file to upload
						</div>
						<div style={inputPanel}>
								<div style={blueButton} onClick={showFile}>
									<FontAwesomeIcon icon="paperclip" style={panelIcon}/>
								</div>
									<input type="file" style={{...fileInput, display:fileDisplay}} ref={refFile}/>
						</div>
					</div>
					<div style={uploadRow}>
						<div style={label}>
							Allocate to a floor
						</div>
						<div style={inputPanel}>
								<select style={thisSelect} onChange={handleSelectChange}>
									<option value="-100">Select</option>
									{optionDisplay}
								</select>
								
						</div>
					</div>
				</div>
				<div style={{...buttonContainer, display:standardDisplay}}>
					<div style={bigBlueButton} onClick={handleSubmit}>
						Upload
					</div>
					<div style={bigBlueButton} onClick={goHome}>
						Cancel
					</div>
					
					
				</div>
				
				<div style={{...processPanel, display:submitDisplay}}>
					<CircularProgress
						color="inherit"
					>
					</CircularProgress>
				</div>
				<div style={{...processPanel, display:successDisplay}}>
					<FontAwesomeIcon icon="check" style={successIcon}/>
				</div>
				<div style={{...processPanel, display:failureDisplay}}>
					<FontAwesomeIcon icon="exclamation-triangle" style={failureIcon}/>
				</div>
				</div>
			</div>
	);
}